import React from 'react';
import RequestResetPassword from 'components/website/auth/RequestResetPassword';

function RequestResetPasswordPage() {
  return <RequestResetPassword />;
}

export default RequestResetPasswordPage;
